import { Message, MessageBox, confirm, Notification } from 'element-ui'
let msg;
// 成功提示
export function successplugIin(data) {
    if (msg) {
        msg.close()
    }
    msg = Message({
        message: data,
        type: 'success',
        center: true,
        showClose: true,
        duration: 5 * 1000
    })
    return Message;


}
//失败提示
export function errorplugIin(data) {
    if (msg) {
        msg.close()
    }
    msg = Message({
        message: data,
        type: 'error',
        center: true,
        showClose: true,
        duration: 5 * 1000
    })
    return msg;
}
//警告提示
export function warningplugIin(data) {
    if (msg) {
        msg.close()
    }
    msg = Message({
        message: data,
        type: 'warning',
        center: true,
        showClose: true,
        duration: 5 * 1000
    })
    return Message;


}
//警告提示
export function warnnotification(data) {
    if (msg) {
        msg.close()
    }
    msg = Notification({
        title: 'warning',
        message: data,
        type: 'warning',
        duration: 5 * 1000
    });
    return Notification;


}


// WEBPACK FOOTER //
// ./src/utils/information.js